import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";


const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/insert-update-club", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/club-list", {}, headerConfig);
        return response;
};


// const deleteclub = async (data) => {
//     const response = await axios
//         .post(BASE_API_URL + "club/delete", data, headerConfig);
//         return response.data;
//   };




const clubMasterService = {
    save,
    list    
};

export default clubMasterService;